<template>
  <div ref="listcardProceso" class="flex-column">
    <v-row dense>
      <v-col v-for="(item, index) in items" :key="index" cols="12" sm="6" md="4" >
        <v-card
          :id="`Card_Proceso_${index}_${item.sLlave}`"
          outlined
          hover
          ripple
          tabindex="0"
          role="button"
          class="pa-3 proceso-card"
          @click="seleccionar(item)"
          @keyup.enter.prevent="seleccionar(item)"
        >
          <!-- Llave -->
          <div :id="`Info_llave_${index}_${item.sLlave}`" v-if="item.sLlave" class="mt-2 font-weight-bold text-h6 mb-1">
            {{ trunc(item.sLlave, 30) }}
          </div>

          <!-- Estado y Fecha en el mismo nivel -->
          <v-row no-gutters>
            <!-- Fecha -->
            <v-col cols="6" v-if="item.DateLastUpdate">
              <div class="caption font-weight-bold">Fecha creación</div>
              <div class="caption">
                {{ item.DateLastUpdate.date.slice(0,16) }}
              </div>
            </v-col>
            <!-- Estado -->
            <v-col cols="6" class="text-right" v-if="item.sEstadoProceso">
              <div class="caption font-weight-bold">Estado Actual</div>
              <div class="caption">{{ item.sEstadoProceso }}</div>
            </v-col>
          </v-row>
        </v-card>

      </v-col>
    </v-row>
    <div ref="observer"></div>
  </div>
</template>

<script>
export default {
  name: "ListCardProceso",
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      observer: null,
    };
  },
  mounted() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry && entry.isIntersecting) {
          this.$emit("load-more");
        }
      },
      {
        root: this.$el.parentElement, // Our scrollable element
        threshold: 1.0,
      }
    );
    this.observer.observe(this.$refs.observer);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    seleccionar(item) {
      this.$emit("seleccionado", item); // ahora emite 'seleccionado'
    },
    trunc(t, n) {
      return t && t.length > n ? t.substr(0, n) + "…" : (t || "");
    }
  }
};
</script>

<style scoped>

.proceso-card {
  cursor: pointer;
  transition: background-color .12s ease, transform .06s ease;
}
.proceso-card:hover {
  background-color: #f6f8fb;
  transform: translateY(-2px);
}
</style>
